import {
  type SlashMenuActionItem,
  SlashMenuConfigExtension,
} from '@blocksuite/affine/widgets/slash-menu';
import { DatabaseListViewIcon } from '@blocksuite/icons/lit';

const OPEN_MASTER_DATA_QUERY_EVENT = 'affine:open-master-data-query';

type OpenMasterDataQueryEventDetail = {
  docId: string;
};

export function MasterDataQuerySlashMenuExtension() {
  const item: SlashMenuActionItem = {
    name: '主数据查询',
    description: '从主数据平台获取数据',
    icon: DatabaseListViewIcon(),
    group: '9_Custom@0',
    searchAlias: ['主数据', '查询', 'master data', 'query'],
    action: ({ std }) => {
      if (typeof window === 'undefined') {
        return;
      }

      window.dispatchEvent(
        new CustomEvent<OpenMasterDataQueryEventDetail>(
          OPEN_MASTER_DATA_QUERY_EVENT,
          {
            detail: {
              docId: std.host.store.id,
            },
          }
        )
      );
    },
  };

  return SlashMenuConfigExtension('affine:master-data-query', {
    items: [item],
  });
}
